var map = {
	"./images/box-number-brown.png": 257,
	"./images/box-number-gold.png": 258,
	"./images/box-number-lose.png": 259,
	"./images/box-number-score.png": 260,
	"./images/box-number-silver.png": 261,
	"./images/box-number-win.png": 262
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 256;